var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside",
        },
      ],
      staticClass: "dropdown",
      class: { "is-active": _vm.active },
    },
    [
      _c("div", { staticClass: "dropdown-trigger" }, [
        _c(
          "button",
          {
            staticClass: "button",
            attrs: {
              disabled: _vm.disabled,
              "aria-haspopup": "true",
              "aria-controls": "dropdown-menu",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggle.apply(null, arguments)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.label))])]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dropdown-menu",
          attrs: { id: "dropdown-menu", role: "menu" },
        },
        [_c("div", { staticClass: "dropdown-content" }, [_vm._t("default")], 2)]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }